import { REACT_APP_API_URL } from '../../config';
import { Section, SectionDetail } from '../../types/SectionDD'
import { cleanSections } from './DataCleaner'
let persist:any = {};

export const getSections = async (department: string, courseNumber: string, term: string, session: string, campus: string) => {
    const response = await fetch(
        `${REACT_APP_API_URL}api/sections?subject=${department}&number=${courseNumber}&term=${term}&session=${session}&campus=${campus}`
    )
    const data = await response.json()
    console.log(data.sections)
    for (let j = 0; j<data['sections'].length; j++) {
        data['sections'] = data['sections'].filter((item: { schedule: string | any[] }) => item.schedule.length>0)
    }
    const dataCleaned = cleanSections(data.sections, term)
    console.log(dataCleaned)
    if (persist[department + campus+ courseNumber]) {
      dataCleaned.sections.forEach(sec => {
        if (!persist[department + campus+ courseNumber][sec.section]) {
          persist[department + campus+ courseNumber][sec.section] = sec
        }
      })
    } else {
      persist[department + campus+ courseNumber] = {};
      dataCleaned.sections.forEach(sec => {
        persist[department + campus+ courseNumber][sec.section] = sec
      })
    }
    return dataCleaned
}

//getSectionDetail
export const getSection = (
    department: string,
    courseNumber: string,
    session: string,
    section: string,
    campus: string
) => {
    if (persist[department + campus+courseNumber]) {
      if (persist[department + campus+courseNumber][section]) {
        const currentCourse:Section = persist[department + campus+courseNumber][section];
        let restrictedSeatsRemaining = 0;
        let generalSeatsRemainings = 0;
        let currentlyRegistered = 0;
        let totalSeatsRemaining = 0;
        if ((currentCourse.remainingReservedSeats !== undefined) 
          && (currentCourse.remainingUnreservedSeats !== undefined)
          && (currentCourse.reservedCapacity !== undefined)
          && (currentCourse.sectionCapacity !== undefined)
        ) {
          restrictedSeatsRemaining = Number(currentCourse.remainingReservedSeats);
          generalSeatsRemainings = Number(currentCourse.remainingUnreservedSeats);
          totalSeatsRemaining = restrictedSeatsRemaining+generalSeatsRemainings;
          currentlyRegistered = Number(currentCourse.reservedCapacity)+Number(currentCourse.sectionCapacity)-totalSeatsRemaining;
        }
        return {
          building: "N/A",
          currentlyRegistered: String(currentlyRegistered),
          generalSeatsRemainings: String(generalSeatsRemainings),
          restrictedSeatsRemaining: String(restrictedSeatsRemaining),
          totalSeatsRemaining: String(totalSeatsRemaining),
          instructorUrl:"['N/A']",
          instructor: "['N/A']",
          restrictedconditions:"N/A",
          room: "N/A",
          roomUrl:"N/A",
        }
      }
    }   
    return {
      building: "N/A",
      currentlyRegistered: "0",
      generalSeatsRemainings: "0",
      restrictedSeatsRemaining: "0",
      totalSeatsRemaining: "0",
      instructorUrl:"['N/A']",
      instructor: "['N/A']",
      restrictedconditions:"N/A",
      room: "N/A",
      roomUrl:"N/A",
    }
    // else {
    //   return {
    //     building: "N/A",
    //     currentlyRegistered: "",
    //     generalSeatsRemainings: "",
    //     restrictedSeatsRemaining: "",
    //     totalSeatsRemaining: "",
    //     instructorUrl:["N/A"],
    //     instructors: ["N/A"],
    //     restrictedconditions:"N/A",
    //     room: "N/A",
    //     roomUrl:"N/A",
    //   }
    // }

    // console.log(stop_here)
    // const response = await fetch(
    //     `${REACT_APP_API_URL}api/${session}/sections/detail?subject=${department}&number=${courseNumber}&section=${section}&campus=${campus}`
    // )
    // const data = await response.json()
    // return data
}
